import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'root-header-nav-subitems',
  standalone: true,
  imports: [],
  templateUrl: './header-nav-subitems.component.html',
  styleUrl: './header-nav-subitems.component.scss',
})
export class HeaderNavSubitemComponent implements AfterViewInit, OnDestroy {
  private resizeSubscription!: Subscription;
  routeLinkedSubItems = this.menuService.renderedChildren.asReadonly();
  topMenuItem: string = '';
  @ViewChild('subitemContainer') subitemContainer!: ElementRef;

  constructor(
    private menuService: MenuService,
    private router: Router,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {}

  keepOpen(topMenuItem: string) {
    this.menuService.onHoverEnter(topMenuItem);
  }

  setToClose() {
    this.menuService.onHoverLeave();
  }

  navigate(path: string) {
    this.router.navigateByUrl(path);
  }
  ngAfterViewInit() {
    this.resizeSubscription = this.menuService.offSetvalue$.subscribe((offSet) => {
      this.renderer.setStyle(this.subitemContainer.nativeElement, 'margin-right', offSet + 'px');
      this.cdr.detectChanges();
    });
  }
  ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }
}
